import create from 'zustand';
import { IVideoData } from '@interfaces/video.interface';
import { VideoJsPlayer } from 'video.js';

interface VideoStore {
  video: IVideoData | null;
  editorPlayerRef: VideoJsPlayer | null;
  editorPlayerElementRef: HTMLVideoElement | null;
  editorPlayerPaused: boolean;
  editorPlayerDuration: number;
  editorPlayerCurrentTime: number;
  editorPlayerRange: {
    startTime: number;
    endTime: number;
  } | null;
  editorPlayerCurrentProgress: number;

  setVideo: (video: IVideoData) => void;
  disposeVideo: () => void;
  setEditorPlayerRef: (player: VideoJsPlayer) => void;
  setEditorPlayerElementRef: (element: HTMLVideoElement) => void;
  setEditorPlayerPaused: (paused: boolean) => void;
  setEditorPlayerDuration: (duration: number) => void;
  setEditorPlayerCurrentTime: (time: number) => void;
  setEditorPlayerRange: (range: VideoStore['editorPlayerRange']) => void;
  disposeEditorPlayer: () => void;
}

const useVideoStore = create<VideoStore>((set, get) => ({
  video: null,
  editorPlayerRef: null,
  editorPlayerElementRef: null,
  editorPlayerPaused: true,
  editorPlayerDuration: 0,
  editorPlayerCurrentTime: 0,
  editorPlayerRange: null,
  get editorPlayerCurrentProgress() {
    const { editorPlayerDuration, editorPlayerCurrentTime } = get();

    return editorPlayerCurrentTime / editorPlayerDuration;
  },

  setVideo(video) {
    set({ video });
  },
  disposeVideo() {
    set({ video: null });
  },
  setEditorPlayerRef(player) {
    set({ editorPlayerRef: player });
  },
  setEditorPlayerElementRef(element) {
    set({ editorPlayerElementRef: element });
  },
  setEditorPlayerPaused(paused) {
    set({ editorPlayerPaused: paused });
  },
  setEditorPlayerDuration(duration) {
    set({ editorPlayerDuration: duration });
  },
  setEditorPlayerCurrentTime(time) {
    set({ editorPlayerCurrentTime: time });
  },
  setEditorPlayerRange(range) {
    set({ editorPlayerRange: range });
  },
  disposeEditorPlayer() {
    set({
      editorPlayerRef: null,
      editorPlayerElementRef: null,
      editorPlayerPaused: true,
      editorPlayerDuration: 0,
      editorPlayerCurrentTime: 0,
      editorPlayerRange: null,
    });
  },
}));

export { useVideoStore };
